export default "__VITE_ASSET__Bobhjv5q__"